import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const AttrBatchIcon = React.memo<IconProps>(({ 
  className = '',
  size = 24,
  color = 'currentColor',
  onClick,
  strokeWidth
}) => (
  <BaseIcon
    className={className}
    size={size}
    color={color}
    onClick={onClick}
    viewBox="0 0 24 24"
    strokeWidth={strokeWidth}
  >
    <path d="M9 12C5.69 12 3 9.31 3 6C3 2.69 5.69 0 9 0C12.31 0 15 2.69 15 6C15 9.31 12.31 12 9 12ZM9 2C6.79 2 5 3.79 5 6C5 8.21 6.79 10 9 10C11.21 10 13 8.21 13 6C13 3.79 11.21 2 9 2Z" fill={color}/>
    <path d="M18 20C16 20 14.16 19.68 13.09 19.15C12.12 18.66 11.72 17.48 12.2 16.5L17.1 6.55999C17.44 5.87999 18.56 5.87999 18.89 6.55999L23.79 16.5C24.27 17.48 23.87 18.66 22.9 19.15C21.83 19.69 19.99 20 17.99 20H18ZM18 9.25999L14 17.38C14.58 17.65 15.99 18 18 18C20.01 18 21.39 17.66 21.99 17.37L18 9.26999V9.25999Z" fill={color}/>
    <path d="M10 24H1C0.45 24 0 23.55 0 23V14C0 13.45 0.45 13 1 13H10C10.55 13 11 13.45 11 14V23C11 23.55 10.55 24 10 24ZM2 22H9V15H2V22Z" fill={color}/>
  </BaseIcon>
));

AttrBatchIcon.displayName = 'AttrBatchIcon';
